<script setup>
import {ref} from 'vue'
import Card from "primevue/card";
import Button from 'primevue/button';
import DefaultLayout from '../../layouts/default.vue'
import InputText from "primevue/inputtext";
import InputIcon from "primevue/inputicon";
import IconField from "primevue/iconfield";
import EmployeesTable from "@/components/employee/EmployeesTable.vue";
import EmployeeForm from "@/components/employee/EmployeeForm.vue";
import { useEmployeeStore } from '@/stores/employee.js';
import ActiveArchiveToggle from '@/components/common/ActiveArchiveToggle.vue'
import employeeApi from '@/api/employeeApi.js';
import { usePermissions } from '@/composables/usePermissions.js';


const search = ref('');
const showAddDialog = ref(false);
const employeeStore = useEmployeeStore();
const checked = ref(true); // true = Активные, false = Архив
const activeCount = ref(null);
const archiveCount = ref(null);
const { hasPermission } = usePermissions();


async function fetchEmployeeCounts({ q }) {
  const [activeResp, archiveResp] = await Promise.all([
    employeeApi.getEmployees({ page: 1, q, is_active: true }),
    employeeApi.getEmployees({ page: 1, q, is_active: false }),
  ])
  return {
    active: Number(activeResp?.count ?? 0),
    archive: Number(archiveResp?.count ?? 0)
  }
}

async function fetchArchiveCountOnly({ q }) {
  const archiveResp = await employeeApi.getEmployees({ page: 1, q, is_active: false });
  return Number(archiveResp?.count ?? 0);
}

async function handleSave({ data }) {
  await employeeStore.addEmployee(data);
}

function handleInitialCountLoaded({ count, isActive }) {
  if (isActive === true) {
    activeCount.value = count;
  } else if (isActive === false) {
    archiveCount.value = count;
  }
}

</script>
<template>
  <DefaultLayout>
    <Card class="w-full flex-1 flex flex-col min-h-0"
          :pt="{
            body: { class: 'flex-1 flex flex-col h-full' },
            content: { class: 'p-0 flex-1 flex flex-col min-h-0' }
          }"
    >
      <template #title>
        <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-8">
            <IconField>
              <InputIcon class="pi pi-search" />
              <InputText v-model="search" placeholder="Поиск сотрудника..." />
            </IconField>

            <ActiveArchiveToggle
                v-if="hasPermission('employee.archive_employeeprofile')"
                v-model="checked"
                :search="search"
                :initial-active-count="activeCount"
                :initial-archive-count="archiveCount"
                :skip-initial-load="true"
                :fetchCounts="fetchEmployeeCounts"
                :fetchArchiveCountOnly="fetchArchiveCountOnly"
                onIcon="pi pi-sun"
                offIcon="pi pi-moon"
                widthClass="w-36"
                ariaLabel="Фильтр по активности сотрудников"
            />
          </div>

          <Button
              v-if="hasPermission('employee.add_employeeprofile')"
              label="Добавить сотрудника"
              icon="pi pi-plus"
              severity="info"
              rounded
              @click="showAddDialog = true"
          />
        </div>
      </template>
    <template #content>
      <EmployeesTable :search="search" :is-active="checked" @initial-count-loaded="handleInitialCountLoaded" />
    </template>
  </Card>

  <EmployeeForm
      v-model:visible="showAddDialog"
      @save="handleSave"
  />

  </DefaultLayout>
</template>

<style scoped>
</style>